<p>
  This assumption is used to determine both your expected annual contributions
  to the new Group RRSP, as well as the AMA matching contribution.
</p>
<p>
  Remember – under the new Group RRSP, AMA will make a base contribution of 5% of your regular base earnings
  and will also match 100% of your contribution (up to 5%). This means that,
  if you contribute 5% or more, AMA will contribute 10% of your regular base earnings to
  the new Group RRSP.
</p>